import React from 'react';
import PanelMeasure from '@/layout/components/PanelMeasure';
import UserGroupPanelFull from '../containers/UserGroupPanelFull';
import UserGroupPanelNarrow from '../containers/UserGroupPanelNarrow';

const UserGroupPanel = ({ configuration, onChange }) => (
  <PanelMeasure
    configuration={configuration}
    component={{ full: UserGroupPanelFull, narrow: UserGroupPanelNarrow }}
    onChange={onChange}
  />
);

export default UserGroupPanel;
